<template lang="pug">
div
  .simpleTable
    .thead
      .tr
        .th 排序
        .th 可见
        .th 名称
        .th 别名
        .th 类型
        .th 预设
        .th 只读
        .th 必输
        .th 宽度
        .th 换行
        .th(v-if="isEditAble") 操作
    vuedraggable.tbody(
      v-model="rightModel.formFieldConfigs"
      :options="sortOptions"
      @end="reSortAll()"
      )
      .tr(v-for="(vv1, index1) in rightModel.formFieldConfigs" :key="index1")
        .td
          i.el-icon-rank.move(v-if="isEditAble")
          span(v-else) {{index1+1}}
        .td
          el-tag(v-if="vv1.display" type="success" ) 是
          el-tag(v-else type="danger" ) 否
        .td {{fgetName(vv1)}}
        .td {{vv1.alias}}
        .td {{fitemType(vv1)}}
        .td
        .td
          el-tag(v-if="vv1.readOnly" type="success" ) 是
          el-tag(v-else type="danger" ) 否
        .td
          el-tag(v-if="vv1.required" type="success" ) 是
          el-tag(v-else type="danger" ) 否
        .td {{vv1.width}}
        .td
          el-tag(v-if="vv1.lineFeed" type="success" ) 是
          el-tag(v-else type="danger" ) 否
        .td(v-if="isEditAble")
          el-button(type="text" @click="popShow(vv1)") 编辑
          el-button(type="text" @click="delOne(vv1, index1)" v-if="vv1.expenseItem") 移除

  sysDialog(
    width="40%"
    :title="editPop.title"
    :visible="editPop.isVisible"
    @clickOk="popOk"
    @close="editPop.isVisible=false"
    okText="确定"
    cancelText="取消"
    )
    el-form(label-width="110px" v-if="editPop.isVisible")
      el-form-item(label="字段名称")
        el-input(v-model="editPop.editForm.expenseItemType.name" v-if="editPop.editForm.expenseItem")
        el-input(v-model="editPop.editForm.expenseDaysType.name" v-else-if="editPop.editForm.daysItem")
        el-input(:value="fgetName(editPop.editForm)" disabled v-else)
      el-form-item(label="字段类型")
        el-input(:value="fitemType(editPop.editForm)" disabled)
      el-form-item(label="字段别名" v-if="!editPop.editForm.expenseItem && !editPop.editForm.daysItem")
        el-input(v-model="editPop.editForm.alias")

      template(v-if="editPop.editForm.expenseItem")
        el-form-item(label="标准类型" required)
          selectLocalNormal(
            v-model="editPop.editForm.expenseItemType.standardType"
            :resultList="StandardTypeList"
            valueKey="key"
            labelKey="value"
            )
        template(v-if="editPop.editForm.expenseItemType.standardType")
          el-form-item(label="控制方式" required)
            selectLocalNormal(
              v-model="editPop.editForm.expenseItemType.controlType"
              :resultList="ControlTypeList"
              valueKey="key"
              labelKey="value"
              )
          el-form-item(label="天数来源" required)
            selectLocalNormal(
              v-model="editPop.editForm.expenseItemType.daysSource"
              :resultList="DaysSourceList"
              valueKey="key"
              labelKey="value"
              )
      template(v-else-if="editPop.editForm.daysItem")
        el-form-item(label="计算原则" required)
          selectLocalNormal(
            v-model="editPop.editForm.expenseDaysType.calculationRule"
            :resultList="CalculationRuleList"
            valueKey="key"
            labelKey="value"
            )
        el-form-item
          el-checkbox(v-model="editPop.editForm.expenseDaysType.leastOneDay") 至少有1天
          el-checkbox(v-model="editPop.editForm.expenseDaysType.containHeadTail") 包含头尾

      el-form-item(label="宽度")
        el-select.width100p(v-model="editPop.editForm.width")
          el-option(:value="8" label="33%" )
          el-option(:value="16" label="66%" )
          el-option(:value="24" label="100%" )
      el-form-item
        el-checkbox(v-model="editPop.editForm.display") 显示
        template(v-if="editPop.editForm.display")
          el-checkbox(v-model="editPop.editForm.required") 必输
          el-checkbox(v-model="editPop.editForm.readOnly" :disabled="!editPop.editForm.showReadOnly") 只读
          el-checkbox(v-model="editPop.editForm.lineFeed") 换行
</template>

<script>
import apiAxios from '@/apiAxios.js'
import { cloneDeep } from '@/common/util/cloneDeep.js'
import { fgetName, fitemType } from '@/ASysUtil/sysFormUtil.js'
export default {
  props: {
    rightModel: null,
    StandardTypeList: Array,
    isEditAble: Boolean,
  },
  computed: {},
  data() {
    return {
      editPop: {
        isVisible: false,
        editItem: {},
        editForm: {},
        title: '新增属性',
      },

      sortOptions: {
        handle: '.move',
      },

      DaysSourceList: [],
      CalculationRuleList: [],
      ControlTypeList: [],
    }
  },
  methods: {
    fgetName,
    fitemType,
    reSortAll() {
      this.rightModel.formFieldConfigs.forEach((vv1, index1) => {
        vv1.sort = index1
      })
    },
    popShow(vv1) {
      this.editPop.editItem = vv1
      this.editPop.editForm = cloneDeep(vv1)
      this.editPop.title = vv1.newItem ? '新增属性' : '修改属性'
      this.editPop.isVisible = true
    },
    delOne(vv1, index1) {
      this.rightModel.formFieldConfigs.splice(index1, 1)
    },
    popOk() {
      Object.assign(this.editPop.editItem, this.editPop.editForm)
      this.editPop.isVisible = false
    },
    async loadDaysSelect() {
      const xhr1 = await apiAxios.get(`/em/enum/DaysSource`)
      this.DaysSourceList = xhr1.data.result
      const xhr2 = await apiAxios.get(`/em/enum/CalculationRule`)
      this.CalculationRuleList = xhr2.data.result
      const xhr3 = await apiAxios.get(`/em/enum/controlType`)
      this.ControlTypeList = xhr3.data.result
    },
  },
  async mounted() {
    await this.loadDaysSelect()
  },
}
</script>
